import React, { useCallback, useEffect, useState } from "react";

import MultiScanForm from "../MultiScanForm/MultiScanForm";
import { Pagination } from "@mui/material";
import { IPaging } from "../../types/interfaces";
import OrderListItem from "./OrderListItem";
import { Pageable, PurchaseOrderPagable } from "../../api/order/generated/src";


interface IOrderItem {

}

// type Pageable  = {
//     totalPages: number;
//     page: number;
//     hasPrevPage: boolean;
//     hasNextPage: boolean;
// }

interface IOrderListProps {

}

const OrderList = (props:IOrderListProps) => {

    const [items, setItems] = useState<IOrderItem[]>();


    const [paging, setPaging] = useState<IPaging>({
        page: 1,
        limit: 10
    });

    const [meta, setMeta] = useState<Pageable>();


    const checkScan = useCallback(async (scanned:string) => {
        // hier ID aus Scan ermitteln

        return null;
    }, []);
    
    const runSearch = useCallback(async (id:string) => {
        
        try {
            // hier die Suche anhand der ID ausführen und weiterleiten

            
        } catch (error) {
            
        }

        return false;
    }, []);

    

    const handlePageChange = (event: React.ChangeEvent<unknown>, page: number) => {


        setPaging((oldPageing) => {

            return {
                ...oldPageing,
                page: page
            }
        })
    }

    const renderPaging = () => {
    
        return (
            <Pagination 
                count={meta?.totalPages} 
                page={meta?.page} 
                onChange={handlePageChange} 
                
                
                // showFirstButton={huItems?.meta?.hasPrevPage}
                // showLastButton={huItems?.meta?.hasNextPage}
                showFirstButton
                showLastButton
                variant="outlined" 
                shape="rounded"
                className="flex items-center justify-end mb-4"
            />
        );
    }

    const renderItems = () => {
        return items?.map((item, index) => {
            return (
                <OrderListItem 
                    key={index}
                    item={item}
                />
            );
        })
    }


    useEffect(() => {
        const fetchData = async () => {

            // const api = new OrderApi()
            // const papi = new ProductApi()

            // const orders = await api.findOrdersByQuery({
            //     limit: paging.limit,
            //     page: paging.page,
            // });

            // const items :IOrderItem[] = []
            // for (const order of orders.items ?? []) {
            //     const product = order.material?.[0].component ? await papi.findProductById({id: order.material?.[0].component}) : undefined

            //     items.push({order: order,
            //                 product: product
            //     })

            // }

            const purchaseOrders:PurchaseOrderPagable = {};

            purchaseOrders.items = [
                {
                    id: "1",
                    annotation: "NS0156.525 - KW30 NC0190.004 - KW32 ND...",
                    externalId: "11169",
                    tsCreated: new Date(Date.parse("11.07.2025 11:05")),
                    vendor: {
                        id: "1",
                        name: "Komet Medical"
                    }
                },
                {
                    id: "2",
                    annotation: "",
                    externalId: "11170",
                    tsCreated: new Date(Date.parse("11.07.2025 11:05")),
                    vendor: {
                        id: "1",
                        name: "Komet Medical"
                    }
                },
                {
                    id: "3",
                    annotation: "Pos. 2 zum gleichen Preis wie KMS2213.5F S...",
                    externalId: "11171",
                    tsCreated: new Date(Date.parse("11.07.2025 11:05")),
                    vendor: {
                        id: "1",
                        name: "Komet Medical"
                    }
                }
            ]

            purchaseOrders.meta = {
                totalPages: 1,
                page: 1,
                hasPrevPage: false,
                hasNextPage: false
            }

            const items = purchaseOrders.items;

           
                       
            setItems(items);

            setMeta(purchaseOrders.meta)
        }

        fetchData();
    }, [paging.limit, paging.page]);
  

    return (
        <div>
            <MultiScanForm 
                checkScan={checkScan}
                runSearch={runSearch}
            />

            {/* <div className="w-[32px] h-[32px]">
                <Scanner 
                    onScanned={handleScannedCallback}
                    // directScan={true}
                    icon={<BsQrCodeScan size={"100%"} />}
                />

            </div> */}
            
            <div className="w-full mt-4">
                <div className="">
                    <div className="w-full">
                        {/* {renderPaging()} */}
                        {items && items?.length > 0 && renderItems()}
                        {renderPaging()}
                    </div>
                </div>
            </div>
        </div>
    )
};

export default OrderList;
